// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  delete_icon,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../Table/Table";
import DateRange from "../DateRange/DateRange";
import { deletes, get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const VowReview = ({ setTotal }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState({
    from: "",
    to: "",
    state: "",
    city: "",
    search: "",
  });
  const [optionsList, setOptionsList] = useState({
    states: [],
    cities: [],
  });

  // states and cities (same filter options the Review list uses)
  const getFilters = async () => {
    const res = await get(URLS.REVIEW_FILTERS);
    if (res?.status === "success") {
      const toOptions = (list) =>
        list?.map((item) => ({ value: item?.id, label: item?.name })) ?? [];
      setOptionsList({
        states: toOptions(res?.states),
        cities: toOptions(res?.cities),
      });
    }
  };

  useEffect(() => {
    getFilters();
  }, []);

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const getList = async (pageNumber = 1) => {
    const { from, to, state, city, search } = selectedFilter;
    const params = new URLSearchParams({
      review_type: "vow",
      page: pageNumber,
    });
    if (search) params.append("search", search);
    if (from && to) {
      params.append("from_date", from);
      params.append("to_date", to);
    }
    if (state) params.append("state", state?.value);
    if (city) params.append("city", city?.value);

    setLoading(true);
    try {
      const res = await get(`${URLS.REVIEW_LIST}?${params.toString()}`);
      if (res?.status === "success") {
        setRows(res?.data || []);
        setTotal?.(res?.count ?? res?.data?.length ?? 0);
        setPagination({
          current_page: pageNumber,
          last_page: res?.total_pages,
        });
      }
    } catch (err) {
      console.error("Failed to fetch vow reviews:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList(page);
  }, [
    selectedFilter.state,
    selectedFilter.city,
    selectedFilter.search,
    page,
  ]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  // same status API the Review list uses (2 = active, 3 = de-active)
  const handleStatus = async ({ id, status }) => {
    const res = await post(URLS.REVIEW_STATUS, {
      review_id: id,
      status: status === 2 ? 3 : 2,
    });
    if (res?.status === "success") {
      toast.success(
        `Review ${status === 2 ? "Deactivated" : "Activated"} Successfully`,
      );
      if (rows.length === 1 && page !== 1) setPage((prev) => prev - 1);
      else getList(page);
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    setLoading(true);
    try {
      const res = await deletes(`${URLS.VOW_REVIEW_EDIT}${deleteId}/`);
      if (res?.status === "success") {
        toast.success(res?.message || "Review deleted successfully");
        setDeleteId(null);
        // go back a page if the last row of a later page was deleted
        if (rows.length === 1 && page !== 1) setPage((prev) => prev - 1);
        else getList(page);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "User Name",
        accessor: "reviewer_name",
        Cell: ({ value, row }) => (
          <div className="text-nowrap">
            <p>{value ?? row.original?.user_name}</p>
            <p>{row.original?.user_id}</p>
          </div>
        ),
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value, row }) => (
          <div className="text-nowrap">
            <p>{value}</p>
            <p>{row.original?.property_code}</p>
          </div>
        ),
      },
      {
        Header: "Property Location",
        accessor: "city",
        Cell: ({ value, row }) => (
          <p className="text-nowrap">{`${value ?? ""}, ${row.original?.state ?? ""}`}</p>
        ),
      },
      {
        Header: "Owner Name",
        accessor: "owner_name",
        Cell: ({ value, row }) => (
          <div className="text-nowrap">
            <p>{value}</p>
            <p>{row.original?.owner_id}</p>
          </div>
        ),
      },
      {
        Header: "Star",
        accessor: "rating",
        Cell: ({ value }) => (
          <p className="text-nowrap">{`${Number(value ?? 0).toFixed(1)} ⭐️`}</p>
        ),
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: ({ value }) => (
          <p
            style={{
              width: "150px",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              wordBreak: "break-word",
            }}
            className="text-wrap"
          >
            {value}
          </p>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => (
          <button
            onClick={() => handleStatus(row.original)}
            className={`${
              value === 2 ? "active-btn" : "deactive-btn"
            } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
          >
            {value === 1 ? "Requested" : value === 2 ? "Active" : "Deactive"}
          </button>
        ),
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div className="d-flex ac-js gap-3">
            <button
              onClick={() =>
                navigate("/add-vow-review", {
                  state: { type: "view", data: row.original },
                })
              }
              className="cust-btn "
            >
              <img src={view_icon} alt="" className=" edit-btn " />
            </button>
            <button
              onClick={() =>
                navigate("/add-vow-review", {
                  state: { type: "edit", data: row.original },
                })
              }
              className="cust-btn "
            >
              <img src={edit_icon} alt="" className=" edit-btn " />
            </button>
            <button
              onClick={() => setDeleteId(row.original.id)}
              className="cust-btn "
            >
              <img src={delete_icon} alt="" className=" edit-btn " />
            </button>
          </div>
        ),
      },
    ],
    [page, rows],
  );

  return (
    <div>
      <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
        <DateRange
          paginationPath="vow-review"
          fromValue={selectedFilter.from}
          toValue={selectedFilter.to}
          setFromDate={(date) => handleChangeFilter("from", date)}
          setToDate={(date) => handleChangeFilter("to", date)}
        />
        <Select
          className="location-search"
          options={optionsList.states}
          placeholder="State"
          isClearable
          value={selectedFilter.state}
          onChange={(e) => handleChangeFilter("state", e)}
        />
        <Select
          className="location-search"
          options={optionsList.cities}
          placeholder="City"
          isClearable
          value={selectedFilter.city}
          onChange={(e) => handleChangeFilter("city", e)}
        />
        <div className="search-input">
          <input
            onChange={(e) => handleChangeFilter("search", e.target.value)}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
        <button
          onClick={() => navigate("/add-vow-review")}
          style={{ backgroundColor: "#5d5fef" }}
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn ">
          + Add New
        </button>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={rows}
        show={!loading}
      />

      {deleteId && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDelete} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => setDeleteId(null)}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VowReview;
